<template>
    <div>
        <div v-if="!ThanksPage"
            class="w-full min-h-screen grid lg:grid-cols-2 place-items-center bg-gray-300 overflow-hidden">

            <div class="w-full h-full flex justify-center items-center">
                <div
                    class="flex flex-col bg-white shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-md w-full max-w-md">
                    <div class="login-img">
                        <img src="@/assets/CODINAFRICA.png" alt="Cod In Africa" />
                    </div>


                    <div class="flex w-full justify-center flex-col gap-3 items-center">
                        <h2 class="font-medium self-center text-xl sm:text-2xl uppercase font text-gray-800">
                            {{ $t('Rejoignez-nous') }}
                        </h2>
                        <p class="font-normal font text-center text-xs uppercase text-gray-800">{{
                               $t("DESCRIPTION DU FORMULAIRE D'INSCRIPTION") }}
                        </p>
                    </div>


                    <form class="flex justify-center flex-col items-center gap-4 w-full py-5">
                        <div class="flex flex-col  w-full">
                            <div class=" relative">
                                <div
                                    class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                                    <span class="material-icons">person</span>
                                </div>

                                <input type="text" name="fullname"
                                    class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-black "
                                    v-model="formData.fullName" :placeholder="$t('Entrez le nom complet')" />
                            </div>
                        </div>
                        <div class="flex flex-col  w-full">
                            <div class=" relative">
                                <div
                                    class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                                    <span class="material-icons">mail</span>
                                </div>

                                <input type="text" name="emailAddress"
                                    class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-black "
                                    v-model="formData.email" :placeholder="$t('enter_email_address')" />
                            </div>
                        </div>
                        <div class="relative flex flex-col  w-full">
                            <span class="material-icons absolute text-gray-500 ml-2 mt-2">location_on</span>
                            <!-- For Country -->

                            <div
                                class=" text-sm sm:text-base placeholder-gray-500  pl-8 rounded-lg border border-gray-400 w-full py-1 focus:outline-none focus:border-black">

                                <v-select  v-model="formData.country" :options="warehouses" label="countryName"
                                    class="text-sm sm:text-base text-gray-500" placeholder="Select a country">
                                    <template slot="prepend">
                                        <v-icon>mdi-earth</v-icon>
                                    </template>

                                    <template slot="option" slot-scope="option">
                                        <img class="flag-img" :src="$f.getCountryCode(option.country)" />
                                        {{ option.countryName }}
                                    </template>

                                </v-select>

                            </div>
                        </div>
                        <div class="flex flex-col  w-full">
                            <div class=" relative">
                                <div
                                    class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                                    <span class="material-icons">phone</span>
                                </div>

                                <input type="text" name="phonenumber"
                                    class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-black "
                                    v-model="formData.phone" :placeholder="$t('Entrez le numéro de téléphone')" />
                            </div>
                        </div>

                        <div class="flex w-full">
                            <button @click.prevent="create()"
                                class="flex relative loidingconfirm items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-green-700 hover:bg-green-700  rounded py-2 w-full transition duration-150 ease-in">
                                <loading></loading>
                                <span class="mr-2 uppercase">{{ $t("S'abonner") }}</span>
                                <span>
                                    <svg class="h-6 w-6" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </form>

                    <div class="flex justify-center items-center ">
                        <button @click="returntologin"
                            class="inline-flex items-center font-bold text-black  hover:text-black text-xs text-center focus:outline-none">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-log-in">
                                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                                    <polyline points="10 17 15 12 10 7" />
                                    <line x1="15" x2="3" y1="12" y2="12" />
                                </svg>
                            </span>
                            <span class="ml-2">{{ $t('Retourner à la connexion') }}</span>
                        </button>

                    </div>
                </div>
            </div>


            <div
                class="w-full ml-24 flex-col h-full  bg-green-700 gap-5 lg:flex hidden justify-center items-center px-16 ">
                <div class="flex flex-col justify-start items-start  gap-5 pr-40">
                    <h1 class="title_subscribe_page">Développez votre e-commerce en Afrique avec <span
                            class="highlighted-text ">ESHIPI</span>.</h1>
                    <p class="description_subscribe_page">L'Afrique est un marché rentable et moins compétitif que d'autres pays. C'est l'occasion de le découvrir et de développer votre activité e-commerce</p>

                    <a href="#" target="_blank"
                        class="bg-yellow-400 rounded-lg font  px-5 py-3 text-md font-semibold text-white shadow hover-effect">
                        {{ $t('En savoir plus') }}
                    </a>
                </div>
            </div>
        </div>


        <transition name="fade">
            <div v-if="ThanksPage"
                class="relative w-full min-h-screen flex justify-center items-center bg-gray-200 overflow-hidden">
                <div class="bg-color w-full h-full absolute left-0 top-0 z-10"></div>
                <div class="flex flex-col justify-center items-center  gap-5 lg:px-64 px-4 -mt-24">
                    <div class="w-32 h-32">
                        <img src="@/assets/verify.gif" alt="Cod In Africa" />
                    </div>

                    <h1 class="title_thank_page">MERCI </h1>
                    <p class="description_thank_page ">Merci de vous être abonné! Votre abonnement est maintenant terminé. Notre
                         soutien
                         L'équipe vous contactera sous peu pour vous aider davantage. Nous sommes ravis de vous avoir à bord
                         et
                         au plaisir de vous offrir un service exceptionnel.</p>

                    <button @click="returntologin"
                        class="bg-black rounded-lg font  px-5 py-3 text-md font-semibold text-white shadow hover-effect">
                        {{ $t('Rentrer à la home page') }}
                    </button>

                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {

    data() {
        return {
            formData: {
                fullName: '',
                email: '',
                country: null,
                phone: ''
            },
            warehouses: [],
            selectContry: '',
            options: this.$countries,
            sent: false,

            ThanksPage: false
        }
    },
    async mounted() {
        await this.getWarehouses();
    },
    methods: {
        async getWarehouses() {
            const filter = { limit: 20 };
            const res = await this.$server.search("warehouses", filter);
            if (res && res.content.results) {
                this.warehouses = res.content.results;
                // for(let i in data){
                // this.warehouses.push({name:this.$f.getCountryNameByCode(this.options,data[i].country),code:data[i].country})
                //}
            } else this.warehouses = [];
        },

        async create() {
            // const countries = []
            // this.formData.country.map(item => {
            //     countries.push(item.country)
            // })
            // this.formData.country = countries

            if (this.checkData()) {
                // var count = this.formData.country.length;
                // console.log('watch----------------------count', count)
                // if (count > 2) this.formData.country = this.$f.getCountryCodeByName(this.options, this.formData.country);

                const data = await this.$server.create("subscribers", 
                  {
                    fullName: this.formData.fullName,
                    email: this.formData.email,
                    country: this.formData.country.country||this.formData.country,
                    phone: this.formData.phone,
                });
                //console.log("HI souka");
                //console.log(data);

                if (data && data._id) {
                    this.selectContry = "";
                    this.formData = {};
                    // alert(this.$t('subscriber_created'), "success");
                    this.ThanksPage = true
                }else  alert(data.content||data, "warning");
            } else {
                alert(this.$t('all_required_field'), "warning");
            }
        },
        checkData() {
            const requiredFiels = ["fullName", "phone", "email", "country"];
            for (let index = 0, len = requiredFiels.length; index < len; index++) {
                if (!(requiredFiels[index] in this.formData)) return false;
            }
            return true;
        },
        returntologin() {
            this.$emit('affichLogin');

        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Tajawal:wght@200;300;400;500;700;800;900&display=swap');

.login-img {
    height: auto;
    width: 157px;
    margin: 0 auto 10px;
    display: block;
    box-sizing: border-box;
    text-align: center;
}

.description_subscribe_page {
    font-family: "Poppins", sans-serif;

    font-size: 15px;
    font-weight: 400;
    line-height: 30px;
    color: white;
    text-align: justify;
}

.title_subscribe_page {
    font-family: "Poppins", sans-serif;

    font-size: 28px;
    font-weight: 600;
    line-height: 50px;
    color: white;
}

.description_thank_page {
    font-family: "Poppins", sans-serif;
    font-size: 17px;
    font-weight: 400;
    line-height: 30px;
    color: black;
    text-align: justify;
    text-align: center;
}

.title_thank_page {
    font-family: "Poppins", sans-serif;

    font-size: 40px;
    font-weight: 700;
    line-height: 40px;
    color: black;
}

.font {
    font-family: "Poppins", sans-serif;

}

.highlighted-text {
    background-image: url('data:image/svg+xml;base64,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');
    background-position: 50% 50%;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 5px;
    background-repeat: no-repeat;
    background-size: cover;
}

.bg-color {
    position: absolute;
    height: 250px;
    width: 400px;

    /* Adjust the height as needed */
    background: linear-gradient(to bottom right, #f2be57 50%, transparent 50%);
    background-position: top left;
    background-size: 100% 100%;

}

.hover-effect {
    transition-property: all;
    transition-duration: 2s;
}

@keyframes jiggle {
    0% {
        transform: rotate(0deg);
    }

    25% {
        transform: rotate(3deg);
    }

    50% {
        transform: rotate(-3deg);
    }

    75% {
        transform: rotate(3deg);
    }

    100% {
        transform: rotate(0deg);
    }
}

.hover-effect:hover {
    animation: jiggle 0.5s ease-in-out infinite;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1.5s;

}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
